



















































































































































































































































































































































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import TitleArea from '@/components/TitleArea.vue';
import {Terapeuta, getTerapeutaById, TerapeutaSteroids} from "@/plugins/utils/terapeutasUtils";
import {pad, timeStringToTime, nl2br, copyArrayJson} from "@/plugins/utils/utils";
import { 
  getMarcacoesHelpers, 
  Imarcacao, 
  DiaSemana, 
  saveMarcacoesServer, 
  DiaSemanaObject, 
  diasSemana 
} from "@/plugins/utils/marcacaoUtils";
import { checkTratamentoAux, Consulta, Tratamentos } from '../plugins/utils/consultaUtils';
import { Cartao } from '../plugins/utils/cartaoUtils';
import { Utente } from '../plugins/utils/utentesUtils';

// type TerapeutaSteroids = {activo: boolean; dados: Terapeuta; horas: string[]};

type DadosMarcacao = {
  terapeuta?: Terapeuta;
  hora?: string;
  dia?: DiaSemanaObject;
  hora_transporte?: boolean;
  transporte?: boolean;
};

@Component({
  components: {
    TitleArea
  }
})
export default class Marcacoes extends Vue {
  snackbar = false;
  timeout = 5000;
  terapeutas: TerapeutaSteroids[] = [];
  diasSemana: DiaSemanaObject[] = diasSemana;
  horas: string[] = [];

  primaryColor = this.$vuetify.theme.themes.light.primary;
  
  consulta: Consulta | null = null;
  cartao: Cartao | null = null;
  utente: Utente | null = null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  marcacoesTerapeutas: any[] = []; 
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  marcacoes_old: any[] = [];
  flag_editar = false;
  created() {
    
    // getLastConsulta
    if(this.$route.name){
      this.processUi(this.$route.name as string);
    }

    if(this.$route.params.id_consulta){
      const id_consulta = parseInt(this.$route.params.id_consulta);
      getMarcacoesHelpers(
        id_consulta,
        (helpers) => {
          // console.log("HELPERS",helpers);
          if(helpers.consulta) {
            this.consulta = new Consulta(helpers.consulta);
          }
          if(helpers.cartao) {
            this.cartao = new Cartao(helpers.cartao);
          }
          if(helpers.utente) {
            this.utente = new Utente(helpers.utente);
          }
          helpers.terapeutas.forEach((terapeuta) => {
            this.terapeutas.push({
              activo: true,
              dados: new Terapeuta(terapeuta),
              horas: []
            });
          });
          if(helpers.marcacoes){
            this.marcacoesTerapeutas = helpers.marcacoes;
          }
          

          this.terapeutas.forEach(t => {
            t.horas = this.constructSlots2(t.dados);
          });

          this.horas = this.constructSlots();
          // console.info("terapeutas", this.terapeutas);

          if(helpers.marcacoes_old && helpers.marcacoes_old.length){
            this.marcacoes_old = copyArrayJson(helpers.marcacoes_old);
            

            if(this.flag_editar){
              this.useSugestions();
            }
            else {
              this.dialog_sugestion = true;
            }
          }
          this.$store.commit("setLoading", false);
        },
        () => {
          this.idErrorHandler()
        }
      );
    } else {
      this.idErrorHandler()
    }
  }

  idErrorHandler(): void{
    this.$store.commit("setLoading", false);
    this.$store.commit("setError", {flag: true, text: "Consulta/Utente inválido", status: "error"});
    this.$router.push("/dashboard");
  }

  getTime(stringTime: string): number{
    return timeStringToTime(stringTime);
  }

  checkFirstHour(tempoSlot: number): number{
    let id = 1;
    let hora_inicial = new Date();
    hora_inicial.setSeconds(59);
    hora_inicial.setMinutes(59);
    hora_inicial.setHours(23);
    for (let index = 0; index < this.terapeutas.length; index++) {
      const terapeuta = this.terapeutas[index];
      const horaEntrada = terapeuta.dados.horaEntrada;
      if(horaEntrada != null && tempoSlot === terapeuta.dados.tempoSlot){
        if(horaEntrada.getTime() < hora_inicial.getTime() ){
          hora_inicial = horaEntrada;
          id = terapeuta.dados.id; 
        }
      }
    }
    return id;
  } 

  checkLastHour(tempoSlot: number): number{
    let id = 1;
    let hora_inicial = new Date();
    hora_inicial.setSeconds(0);
    hora_inicial.setMinutes(0);
    hora_inicial.setHours(0);
    for (let index = 0; index < this.terapeutas.length; index++) {
      const terapeuta = this.terapeutas[index];
      const horaSaida = terapeuta.dados.horaSaida;
      if(horaSaida != null && tempoSlot == terapeuta.dados.tempoSlot){
        if(horaSaida.getTime() > hora_inicial.getTime() ){
          hora_inicial = horaSaida;
          id = terapeuta.dados.id; 
        }
      }
    }
    return id;
  }

  checkSmallInterval(): number{
    let id = 1;
    let small = 10000;
    for (let index = 0; index < this.terapeutas.length; index++) {
      const terapeuta = this.terapeutas[index];
      if(terapeuta.dados.tempoSlot < small){
        small = terapeuta.dados.tempoSlot;
        id = terapeuta.dados.id;
      }
    }
    return id;
  }

  constructSlots(): string[]{
    const horas: string[] = [];
    // CHECK FIRST HOUR
    const idMaisCedo = this.checkFirstHour(30);
    // console.log(idMaisCedo);

    // CHECK Last HOUR
    const idMaisTarde = this.checkLastHour(30);
    // console.log(idMaisTarde);

    // CHECK MINOR INTERVAL
    const idSmallInterval = this.checkSmallInterval();
    // console.log(idSmallInterval);

    const tCedo = getTerapeutaById(idMaisCedo, this.terapeutasSimples);
    const tTarde = getTerapeutaById(idMaisTarde, this.terapeutasSimples);
    const tInterval = getTerapeutaById(idSmallInterval, this.terapeutasSimples);
    if(tCedo != null && tTarde != null && tInterval != null){
      const timeStart = tCedo.horaEntrada as Date;
      const timeEnd = tTarde.horaSaida as Date; 
      const interval = tInterval.tempoSlot; 

      let i = timeStart;
      while (i<= timeEnd) {
        horas.push( pad(i.getHours(),2) + ":" + pad(i.getMinutes(), 2));
        i = new Date(i.getTime() + interval*60*1000 );
      }
    }

    return horas;
  }

  constructSlots2(terapeuta: Terapeuta): string[]{
    const horas: string[] = [];

    // console.log("terapeuta", terapeuta.nome);
    // CHECK FIRST HOUR
    const idMaisCedo = this.checkFirstHour(terapeuta.tempoSlot);
    // console.log("id mais cedo",idMaisCedo);

    // CHECK Last HOUR
    const idMaisTarde = this.checkLastHour(terapeuta.tempoSlot);
    // console.log("id mais tarde", idMaisTarde);

    // CHECK MINOR INTERVAL
    // const idSmallInterval = this.checkSmallInterval();
    // console.log(idSmallInterval);

    const tCedo = getTerapeutaById(idMaisCedo, this.terapeutasSimples);
    const tTarde = getTerapeutaById(idMaisTarde, this.terapeutasSimples);
    // console.log(tCedo);
    // console.log(tTarde);
    // const tInterval = getTerapeutaById(idSmallInterval, this.terapeutasSimples);
    if(tCedo != null && tTarde != null){
    
      const timeStart = tCedo.horaEntrada as Date;
      const timeEnd = tTarde.horaSaida as Date; 
      const timeAlmoco = terapeuta.horaAlmoco as Date; 
      const timeTarde = terapeuta.horaTarde as Date; 
      const interval = terapeuta.tempoSlot; 

      let i = timeStart;
      while (i< timeAlmoco) {
        horas.push( pad(i.getHours(),2) + ":" + pad(i.getMinutes(), 2));
        i = new Date(i.getTime() + interval*60*1000 );
      }
      
      i = timeAlmoco;
      while (i< timeTarde) {
        horas.push( pad(i.getHours(),2) + ":" + pad(i.getMinutes(), 2));
        i = new Date(i.getTime() + interval*60*1000 );
      }

      i = timeTarde;
      while (i<= timeEnd) {
        horas.push( pad(i.getHours(),2) + ":" + pad(i.getMinutes(), 2));
        i = new Date(i.getTime() + interval*60*1000 );
      }

    }

    return horas;
  }

  get terapeutasSimples(): Terapeuta[]{
    const newTerapeutas: Terapeuta[] = [];

    this.terapeutas.forEach(t => {
      newTerapeutas.push(t.dados);
    })

    return newTerapeutas;
  }

  get terapeutasMapas(): TerapeutaSteroids[]{
    const newTerapeutas: TerapeutaSteroids[] = [];

    this.terapeutas.forEach(t => {
      if(t.activo)
        newTerapeutas.push(t);
    })

    return newTerapeutas;
  }

  checkHoraOut(terapeuta: TerapeutaSteroids, hora: string): boolean{
    if(
      terapeuta.dados.horaEntrada.getTime() > this.getTime(hora) || 
      terapeuta.dados.horaSaida.getTime() < this.getTime(hora) || 
      (terapeuta.dados.horaAlmoco.getTime() <= this.getTime(hora) 
        && terapeuta.dados.horaTarde.getTime() > this.getTime(hora
        )
      )
    ) {
      return true;
    } else {
      return false;
    }
  }

  checkHoraTransporte(terapeuta: TerapeutaSteroids, hora: string): boolean{
    if(
      terapeuta.dados.horaTransporte.getTime() <= this.getTime(hora) && 
      terapeuta.dados.horaFimTransporte.getTime() > this.getTime(hora)
    ) {
      return true;
    } else {
      return false;
    }
  }

  confirmDialog = false;
  confirmDeleteDialog = false;
  dados_card: DadosMarcacao = {};
  dados_card_delete: DadosMarcacao = {};
  openConfirm(terapeuta: TerapeutaSteroids, dia: DiaSemanaObject, hora: string): void{
    // se for necessário bloquear a um terapeuts -> !this.checkNotChoosen(terapeuta.id) &&
    if(
      !this.checkHoraOut(terapeuta, hora) && 
      this.cartao && this.consulta && 
      !this.checkSlotChoosen(terapeuta.dados.id, dia, hora) && 
      this.checkDiaTrabalho(terapeuta, dia.value as DiaSemana)
    ){
      this.dados_card.terapeuta = terapeuta.dados;
      this.dados_card.hora = hora;
      this.dados_card.dia = dia;
      this.dados_card.hora_transporte = this.checkHoraTransporte(terapeuta, hora);
      this.dados_card.transporte = this.cartao.transporte;
      this.confirmDialog = true;
      this.dados_card.terapeuta.id

    } else if(this.checkSlotChoosen(terapeuta.dados.id, dia, hora)){
      this.dados_card_delete.terapeuta = terapeuta.dados;
      this.dados_card_delete.hora = hora;
      this.dados_card_delete.dia = dia;
      this.confirmDeleteDialog = true;
    }
  }

  deleteMarcacao(): void{
    for (let i = 0; i < this.marcacoes.length; i++) {
      const marcacao = this.marcacoes[i];
      if(
        marcacao.terapeuta && 
        marcacao.dia && 
        this.dados_card_delete && 
        this.dados_card_delete.terapeuta &&
        this.dados_card_delete.dia &&
        marcacao.terapeuta.id == this.dados_card_delete.terapeuta.id && 
        marcacao.hora == this.dados_card_delete.hora && 
        marcacao.dia.value == this.dados_card_delete.dia.value 
      ) {
        this.marcacoes.splice(i,1);
        i = this.marcacoes.length;
      }
      
    }
    this.confirmDeleteDialog = false;
  }

  confirmDeleteAllDialog = false;
  deleteAllMarcacoes(): void{
    this.marcacoes = [];
    this.confirmDeleteAllDialog = false;
  }

  getTotalSlotTerapeuta(id_terapeuta: number, dia: string, hora: string): number | null{
    let total: number | null = null;
    if(
      this.marcacoesTerapeutas[id_terapeuta] && 
      this.marcacoesTerapeutas[id_terapeuta][dia] &&
      this.marcacoesTerapeutas[id_terapeuta][dia][hora]
    ){
      total = this.marcacoesTerapeutas[id_terapeuta][dia][hora].length;
    }
    if(total == 0) total = null;
    return total;
  }

  checkSlotEspecial(id_terapeuta: number, dia: string, hora: string): boolean{
    let retturn_flag = false;
    if(
      this.marcacoesTerapeutas[id_terapeuta] && 
      this.marcacoesTerapeutas[id_terapeuta][dia] &&
      this.marcacoesTerapeutas[id_terapeuta][dia][hora]
    ){
      const array = this.marcacoesTerapeutas[id_terapeuta][dia][hora];
      for (let index = 0; index < array.length; index++) {
        const item = array[index];
        if(item.flag_especial == 1){
          retturn_flag = true;
          index = array.length;
        }
      }
    }
    return retturn_flag;
  }

  marcacoes: DadosMarcacao[] = [];
  get marcacoesOrdered(): DadosMarcacao[]{
    for (let j = 0; j < this.marcacoes.length; j++) {
      let min = 10000, index = -1, min_hora = "23:59";
      for (let i = j; i < this.marcacoes.length; i++) {
        const marcacao_compare = this.marcacoes[i];
        if(marcacao_compare.dia && marcacao_compare.hora){
          if(Math.min(marcacao_compare.dia.index, min) === marcacao_compare.dia.index && marcacao_compare.dia.index != min){
            min = marcacao_compare.dia.index;
            min_hora = marcacao_compare.hora;
            index = i;
          }
          else if(marcacao_compare.dia.index == min && marcacao_compare.hora < min_hora){
            min_hora = marcacao_compare.hora;
            index = i;
          }
        }
      }
      const helper = this.marcacoes[index];
      this.marcacoes[index] = this.marcacoes[j];
      this.marcacoes[j] = helper;
    }
    return this.marcacoes;
  }

  especial = false;
  saveMarcacao(): void{
    this.marcacoes.push(this.dados_card);
    this.dados_card = {};
    
    this.confirmDialog = false;

    if(this.checkTotalTerapeutas() > 1){
      this.snackbar = true;
    }
  }

  checkTotalTerapeutas(): number{
    const total: number[] = [];
    this.marcacoes.forEach(item => {
      if(item.terapeuta && !total.includes(item.terapeuta.id)){
        total.push(item.terapeuta.id);
      }
    });
    return total.length;
  }

  checkSlotChoosen(id_terapeuta: number, dia: DiaSemanaObject, hora: string): boolean{
    if(this.marcacoes.length == 0){
      return false;
    }
    else {
      let found = false;
      for (let i = 0; i < this.marcacoes.length; i++) {
        const marcacao = this.marcacoes[i];
        if(
          marcacao.hora && marcacao.dia && marcacao.terapeuta && 
          marcacao.terapeuta.id == id_terapeuta &&
          marcacao.hora == hora && 
          marcacao.dia.value == dia.value
        ){
          found = true;
          i = this.marcacoes.length;
        }
      }
      return found;
    }
  }

  checkDiaSelected(dados: DadosMarcacao): boolean{
    let used = false;
    for (let index = 0; index < this.marcacoes.length; index++) {
      const marcacao = this.marcacoes[index];
      if(marcacao.dia && dados.dia && marcacao.dia.value == dados.dia.value){
        used = true;
        index = this.marcacoes.length;
      }
    }
    return used;
  }

  checkNotChoosen(id_terapeuta: number): boolean{
    if(this.marcacoes.length == 0){
      return false;
    }
    else if(!id_terapeuta){
      return true;
    }
    else{
      let found = true;
      for (let i = 0; i < this.marcacoes.length; i++) {
        const item = this.marcacoes[i];
        if(item.terapeuta && item.terapeuta.id == id_terapeuta){
          i = this.marcacoes.length;
          found = false;
        }
      }  
      return found;
    }
  }

  checkDiaTrabalho(terapeuta: TerapeutaSteroids, dia_semana: DiaSemana): boolean{
    if(terapeuta.dados.horarios.length == 0){
      return true;
    } 
    else{
      let flag_found = 0;
      for (let index = 0; index < terapeuta.dados.horarios.length; index++) {
        const horario = terapeuta.dados.horarios[index];
        if(horario.dia_semana == dia_semana){
          index = terapeuta.dados.horarios.length;
          flag_found = 1;
        }
      }
      if(flag_found == 1) return true;
      else return false;
    }
  }

  confirmConsultaDialog = false;
  saveAction(): void{
    // console.log(this.marcacoes);
    if(this.marcacoes.length > 0 && this.consulta != null){
      this.$store.commit("setLoading", true);
      // tratar marcacoes
      const marcacoesServer: Imarcacao[] = [];
      this.marcacoes.forEach((marcacaoObj) => {
        const newMarc: Imarcacao = {
          id_consulta: this.consulta ? this.consulta.id : 0,
          activo: 1,
          hora: marcacaoObj.hora ? marcacaoObj.hora : "",
          dia_semana: marcacaoObj.dia ? marcacaoObj.dia.value as DiaSemana : "segunda" as DiaSemana,
          id_terapeuta: marcacaoObj.terapeuta ? marcacaoObj.terapeuta.id : 0,
          flag_especial: this.especial
        }
        marcacoesServer.push(newMarc);
      });

      saveMarcacoesServer(
        marcacoesServer,
        () => {
          this.$store.commit("setLoading", false);
          this.$store.commit("setError", {flag: true, text: "Operação feita com sucesso!", status: "success"});
          if(this.flag_editar){
            this.$router.back();
          }
          else{
            if(this.marcacoes.length >= 4 && this.cartao && this.cartao.cartaoForm && this.cartao.cartaoForm.id){
                this.confirmConsultaDialog = true;
            }
            else{
              this.$router.push("/dashboard");
            }
          }
        },
        () => {
          this.$store.commit("setError", {flag: true, text: "Ocorreu um erro ao inserir no servidor...", status: "error"});
          this.$store.commit("setLoading", false);
        }
      );
    }
    else{
      this.$store.commit("setError", {flag: true, text: "Por favor seleccione marcações.", status: "error"});
    }
  }


  // DIALOG SUGESTION
  dialog_sugestion = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  headers_m_s: Array<any> = [
    {
      text: "Terapeuta",
      align: 'start',
      sortable: true,
      value: 'terapeuta',
    },
    {
      text: "Hora",
      align: 'start',
      sortable: true,
      value: 'hora',
    },
    {
      text: "Dia",
      align: 'start',
      sortable: true,
      value: 'dia_semana',
    },
    {
      text: "Longo / Pesado",
      align: 'start',
      sortable: true,
      value: 'flag_especial',
    }
  ];
  get itensPage(): number {
    if( !(this.$store.getters.userData && this.$store.getters.userData.itens_pag) ){
      return 10;
    }
    else{
      return this.$store.getters.userData.itens_pag;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  footerOptions: any = {
    "items-per-page-options": [this.itensPage, -1],
    "items-per-page-text": "Linhas/página",
    "items-per-page-all-text": "Todos"
  } 

  useSugestions(){
    this.marcacoes_old.forEach(item => {
      let terapeuta: Terapeuta | null = null;
      for (let index = 0; index < this.terapeutas.length; index++) {
        const element = this.terapeutas[index];
        if(element.dados.id == item.id_terapeuta){
          terapeuta = element.dados;
          index = this.terapeutas.length;
        }
      }
      let dia_semana: DiaSemanaObject | null = null;
      for (let index = 0; index < this.diasSemana.length; index++) {
        const element = this.diasSemana[index];
        if(element.value == item.dia_semana){
          dia_semana = element;
          index = this.terapeutas.length;
        }
      }
      if(terapeuta != null && dia_semana != null){
        const newMArc: DadosMarcacao = {
          terapeuta: terapeuta,
          hora: item.hora,
          dia: dia_semana
        }
          
        this.marcacoes.push(newMArc);
      }
    });
    
    this.dialog_sugestion = false;
  }
  
  

  // UI MODIFICATIONS
  titleArea = "Marcações";
  flagTimeline = false;
  processUi(route: string): void{
    if(route == "ProcessarConsultaM"){
      this.titleArea = "Processar Consulta";
      this.flagTimeline = true;
    }
    else if(route == "EditarMarcacoes"){
      this.titleArea = "Editar Marcações";
      this.flagTimeline = false;
      this.flag_editar = true;
    }
  }
  get title(): string{
    return this.titleArea;
  }
  get timeline(): boolean{
    return this.flagTimeline;
  }

  tratamentosDividedDinamico(tratamento: string): Tratamentos | null{
    if(tratamento){
      return checkTratamentoAux(tratamento, this.$store.getters.separatorAux);
    } else {
      return null;
    }
  }
  get tratamentosDivided(): Tratamentos | null{
    if(this.cartao){
      return checkTratamentoAux(this.cartao.tratamento, this.$store.getters.separatorAux);
    } else {
      return null;
    }
  }

  nl2brLocal(text: string): string{
    return nl2br(text, false);
  }
}

